import { throttle } from 'lodash';
import { dispatch } from 'redux/store';
import { setTimestamp } from 'redux/modules/timestamp/actions';
import IdleTimer from 'react-idle-timer';
import { useSelector } from 'react-redux';
import { timestampSelector } from 'redux/modules/timestamp/selectors';
import { isLoggedInSelector } from 'redux/modules/session/selectors';
import { AuthorizationService } from 'services/authorization/authorization';
import React, { useEffect } from 'react';
import moment from 'moment';
import { lockScreenTimeout } from 'config/app.config';

const THROTTLE_LIMIT = 3000;

const LockScreenManager = () => {
	const timestamp = useSelector(timestampSelector);
	const isLoggedIn = useSelector(isLoggedInSelector);

	const onIdle = () => {
		if (isLoggedIn) {
			AuthorizationService.lockScreen();
		}
	};

	const updateTimestamp = throttle(
		() => {
			const currentTimestamp = moment().format('x');
			dispatch(setTimestamp(currentTimestamp));
		},
		THROTTLE_LIMIT,
		{ leading: false }
	);

	const onAction = () => {
		if (isLoggedIn) {
			updateTimestamp();
		}
	};

	useEffect(() => {
		if (isLoggedIn) {
			const currentTimestamp = moment().format('x');
			const milliseconds = Number(currentTimestamp) - Number(timestamp);
			if (milliseconds >= lockScreenTimeout || !timestamp) {
				AuthorizationService.lockScreen();
			}
		}
		// eslint-disable-next-line
	}, []);

	return <IdleTimer onIdle={onIdle} timeout={lockScreenTimeout} onAction={onAction} />;
};

export default LockScreenManager;
